import { GameConstants } from "../../../GameConstants";
import { GameVars } from "../../../GameVars";
import { BoardContainer } from "../BoardContainer";
import { UndoContainer } from "../UndoContainer";
import { BoardClearedAnimation } from "./BoardClearedAnimation";

export class AnimatedTile extends Phaser.GameObjects.Container {

    private tile: Phaser.GameObjects.Image;
    private dx: number;
    private dy: number;
    private a: number;
    private n: number;
    private f: number;

    constructor(scene: Phaser.Scene, type: string, x: number, y: number) {
        
        super(scene);

        this.type = type;

        this.x = 0;
        this.y = 0;
        this.f = 0;
        this.dx = -(4 + 15 * Math.random());
        this.dy = -(8 + 8 * Math.random());
        this.a = Math.random() * 2 + .85;

        this.n = 4;

        this.tile = this.scene.add.image(x, y, "texture_atlas_1", this.type);
        this.tile.setOrigin(BoardContainer.TILE_WIDTH / this.tile.width, BoardContainer.TILE_HEIGHT / this.tile.height);
        this.tile.scaleX = UndoContainer.TILE_SCALE * GameVars.scaleX;
        this.tile.scaleY = UndoContainer.TILE_SCALE;
        this.add(this.tile);
    }

    public update(): void {

        this.f ++;

        if (this.f === 200) {

            this.scene.tweens.add({
                targets: this,
                alpha: 0,
                duration: 1000,
                onComplete: () => {
                    this.destroy();
                    BoardClearedAnimation.currentInstance.removeTile(this);
                }
            });

            return;
        }
        
        this.tile.x += this.dx;
        this.tile.y += this.dy;

        this.dy += this.a;

        if (this.tile.x >= GameConstants.GAME_WIDTH || this.tile.x <= 0) {
            
            this.dx = -this.dx;
        }

        if (this.tile.y >= GameConstants.GAME_HEIGHT - BoardContainer.TILE_HEIGHT / 2) {

            this.dy = -this.dy;
            
            if (this.n > 0) {
                this.n --;
                this.dy *= 1.25;
            }
        }

        const tile = new Phaser.GameObjects.Image(this.scene, this.tile.x, this.tile.y, "texture_atlas_1", this.type);
        tile.scaleX = UndoContainer.TILE_SCALE * GameVars.scaleX;
        tile.scaleY = UndoContainer.TILE_SCALE;
        this.add(tile);

        this.bringToTop(this.tile);

        this.scene.tweens.add({
            targets: tile,
            scaleX: .25 * GameVars.scaleX,
            scaleY: .25,
            alpha: 0,
            duration: 400,
            delay: 800,
            onComplete: () => {
                tile.destroy();
            }
        });
        
    }
}
